<ng-container *ngIf="documents$ | async as documents">
	<app-container class="rounded-lg w-full bg-white border">
		<div class="flex items-center justify-between" *ngIf="documents.length > 0">
			<h4 class="mb-0 mr-10">
				Documents <span class="font-bold">({{ documents.length }})</span>
			</h4>
			<app-button
				*ngIf="!disabled"
				[icon]="ICON.UPLOAD"
				(click)="openUploadModal()"
				>Upload</app-button
			>
		</div>
		<div class="max-h-[300px] overflow-y-auto p-1">
			<div
				class="flex justify-between bg-grey-veryLight overflow-hidden rounded-xl p-3 my-2 cursor-pointer"
				*ngFor="let doc of documents$ | async"
				(click)="openDocument(doc)"
			>
				<div class="flex items-center w-full">
					<div
						class="flex items-center justify-center bg-grey-lighter p-2 rounded-md w-12 h-12"
					>
						<app-icon
							class="text-2xl text-red"
							[icon]="ICON.PDF"
							[iconStyle]="ICON_STYLE.SOLID"
						></app-icon>
					</div>
					<div class="flex flex-1 p-3 justify-between overflow-hidden">
						<div class="flex flex-col">
							<p class="text-sm text-grey-dark">
								{{ mortgageSupTypeStrings[doc?.subType] | uppercase }}
							</p>
							<span
								class="font-bold text-ellipsis w-full"
								[matTooltip]="doc?.name?.length > 60 ? doc?.name : null"
							>
								{{
									doc?.name?.length > 60
										? doc?.name.slice(0, 60) + '...'
										: doc.name
								}}
							</span>
							<p class="text-sm text-grey">
								Uploaded on: {{ doc?.uploadedAt | date: 'mediumDate' }}
							</p>
						</div>
						<div class="flex items-center justify-center">
							<app-button
								btn="clear"
								[icon]="ICON.KEBAB"
								[matMenuTriggerData]="{ doc: doc }"
								[matMenuTriggerFor]="dropdown"
								(click)="onKebabClick($event)"
							></app-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<app-sale-file-upload
			*ngIf="documents.length === 0"
			type="modal"
			class="w-full h-fit mortgage-document-intercom-bot"
			label="Upload mortgage documents"
			[saleId]="matterId"
			[contextId]="mortgage?.id"
			[documentType]="mortgageDocumentType"
		></app-sale-file-upload>
	</app-container>
</ng-container>

<mat-menu xPosition="before" #dropdown="matMenu">
	<ng-template matMenuContent let-doc="doc">
		<div
			mat-menu-item
			*ngFor="let option of kebabOptions"
			(click)="onKebabSelect(doc, option.value)"
		>
			<div class="flex gap-2 px-3" [class]="option.classes?.join(' ')">
				<app-icon class="text-base" [icon]="option.icon"></app-icon>
				<span>{{ option.name }}</span>
			</div>
		</div>
	</ng-template>
</mat-menu>
